import React, { useRef } from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { useContainBox } from 'react-canvas-resize';

const useStyles = makeStyles(() => ({
	component: ({ box }) => ({
		width: box.width,
		height: box.height,
		marginLeft: box.left,
		marginTop: box.top,
	}),
}));

export default function Resize(props) {
	const { className, ratio, component } = props;

	const ref = useRef();
	const box = useContainBox(ref, ratio);

	const classes = useStyles({ box });

	const Component = component({
		className: classes.component,
	});

	return (
		<div
			ref={ref}
			className={className}
			style={{ overflow: 'hidden' }}
		>
			{Component}
		</div>
	);
}

Resize.defaultProps = {
	className: undefined,
};

Resize.propTypes = {
	className: propTypes.string,
	ratio: propTypes.string.isRequired,
	component: propTypes.func.isRequired,
};
